import React from "react";
import Dhtable from "../components/Dhtable";
import Dnav from "../components/Dnav"


function Dhistory() {
    return (
        <>
            <Dnav />
            <Dhtable />
        </>
    )
}

export default Dhistory;